<template>
    <base-dialog :value="dialog" :title="title" :width="420" @input="onInput" @close="hide">
        <div class="form-group">
            <span class="form-label">{{ $t('common.name') }}</span>
            <kimsa-text-field :placeholder="placeholder" :value="name" @change="name = $event" dense force-value />
        </div>

        <div v-if="withAmount" class="form-group mt-4">
            <span class="form-label">{{ $t('business.amount_this_month') }}</span>
            <kimsa-text-field placeholder="0" :value="amount" @change="amount = $event" input-mode="numeric" dense
                force-value />
        </div>

        <template v-slot:footer>
            <dialog-actions :confirm-label="confirmLabel" :disabled="!valid" @cancel="hide" @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import { parseAmount } from "@/utils/Business";

export default {
    name: "CashEntryDialog",
    components: { BaseDialog, DialogActions, KimsaTextField },
    data() {
        return {
            dialog: false,
            mode: 'area',
            name: '',
            amount: '',
        }
    },
    computed: {
        withAmount(vm = this) {
            return vm.mode === 'concept' || vm.mode === 'income'
        },
        valid(vm = this) {
            return !!String(vm.name || '').trim()
        },
        title(vm = this) {
            if (vm.mode === 'rename') return vm.$t('business.rename')
            if (vm.mode === 'concept') return vm.$t('business.new_concept')
            if (vm.mode === 'income') return vm.$t('business.new_income')
            return vm.$t('business.new_area')
        },
        placeholder(vm = this) {
            if (vm.mode === 'concept') return vm.$t('business.concept_placeholder')
            if (vm.mode === 'income') return vm.$t('business.income_placeholder')
            return vm.$t('business.cash_area_placeholder')
        },
        confirmLabel(vm = this) {
            return vm.mode === 'rename' ? vm.$t('common.save') : vm.$t('common.create')
        },
    },
    methods: {
        show(mode = 'area', name = '') {
            const vm = this
            vm.mode = mode
            vm.name = name
            vm.amount = ''
            vm.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onInput(value) {
            if (!value) this.hide()
        },
        save() {
            const vm = this
            if (!vm.valid) return
            vm.$emit('save', {
                name: String(vm.name).trim(),
                amount: parseAmount(vm.amount),
            })
            vm.hide()
        },
    },
}
</script>

<style scoped>
.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-label {
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
}
</style>
